import {Box, Button, Card, CardContent, Chip, IconButton, Stack, Tooltip, Typography} from "@mui/material";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import {lightBlue, orange} from "@mui/material/colors";
import {HugeiconsIcon} from "@hugeicons/react";
import {CheckIcon, Copy01Icon, LockOpenIcon, LockPasswordIcon, Message01Icon, Settings01Icon} from "@hugeicons/core-free-icons";
import {collectionCardSx, collectionCardContentSx, collectionCardTitleSx} from "../../../../components/collectionCardStyles";

export const MCPServerCards = ({servers, onOpen, onCopy, copiedId}) => (
    <Box sx={{display: "grid", gridTemplateColumns: {xs: "1fr", md: "repeat(2, 1fr)", xl: "repeat(3, 1fr)"}, gap: 2}}>
        {servers.length === 0 && <Typography color="text.secondary" sx={{gridColumn: "1 / -1", textAlign: "center", py: 4}}>No servers match your search</Typography>}
        {servers.map(server => {
            const isSecure = server.auth_token === true;
            return (
                <Card key={server.id} onClick={() => onOpen(server)} sx={{...collectionCardSx, cursor: "pointer", minWidth: 0, display: "flex", flexDirection: "column", "&:hover": {transform: "scale(1.01)"}}}>
                    <CardContent sx={collectionCardContentSx}>
                        <Stack direction="row" alignItems="flex-start" justifyContent="space-between" gap={1}>
                            <Button onClick={event => {event.stopPropagation(); onOpen(server);}} sx={collectionCardTitleSx}>
                                {server.name}
                            </Button>
                            <Tooltip title={server.active ? "Active" : "Inactive"}>
                                <Box
                                    role="img"
                                    aria-label={server.active ? "Active" : "Inactive"}
                                    sx={{width: 8, height: 8, borderRadius: "50%", flexShrink: 0, mt: 1,
                                        bgcolor: server.active ? "success.main" : "error.main"}}
                                />
                            </Tooltip>
                        </Stack>
                        <Stack direction="row" alignItems="center" gap={1}
                               onClick={event => event.stopPropagation()}
                               sx={{px: 1.25, py: 0.75, borderRadius: 2, bgcolor: "grey.50", cursor: "default"}}>
                            <LinkOutlinedIcon sx={{fontSize: 18, color: "text.secondary", flexShrink: 0}}/>
                            <Typography
                                sx={{fontSize: 12, fontFamily: "monospace", color: "text.secondary",
                                    flex: 1, minWidth: 0, overflowWrap: "anywhere", userSelect: "text", cursor: "text"}}
                            >
                                {server.endpoint}
                            </Typography>
                            <Tooltip title="Copy endpoint">
                                <IconButton size="small" aria-label={`Copy endpoint for ${server.name}`} onClick={event => {event.stopPropagation(); onCopy(server);}}>
                                    <HugeiconsIcon icon={copiedId === server.id ? CheckIcon : Copy01Icon} size={16}/>
                                </IconButton>
                            </Tooltip>
                        </Stack>
                        <Tooltip title={isSecure ? "Connection is secure" : "Connection may not be secure"}>
                            <Chip
                                icon={<HugeiconsIcon icon={isSecure ? LockPasswordIcon : LockOpenIcon} size={12}/>}
                                label={isSecure ? "Secure" : "Not secure"}
                                size="small" color={isSecure ? "info" : "warning"} variant="outlined"
                                sx={{
                                    fontSize: 10, pl: 0.75, pr: 0.5, py: 0.5,
                                    fontWeight: 500, borderRadius: 2,
                                    bgcolor: isSecure ? lightBlue[50] : orange[100],
                                    border: "none", maxWidth: "100%", alignSelf: "flex-start",
                                }}
                            />
                        </Tooltip>
                        <Box sx={{mt: "auto"}}>
                            <Box sx={{display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1.5}}>
                                {[
                                    {label: "Tools", value: server.tools?.length || 0, icon: Settings01Icon, color: "#64748b", bg: "#f8fafc"},
                                    {label: "Prompts", value: Object.keys(server.prompts || {}).length, icon: Message01Icon, color: "#64748b", bg: "#f8fafc"},
                                ].map(metric => (
                                    <Stack key={metric.label} direction="row" alignItems="center" gap={1} sx={{p: 1, borderRadius: 2, bgcolor: metric.bg}}>
                                        <Box sx={{width: 28, height: 28, borderRadius: 1.5, display: "flex", alignItems: "center", justifyContent: "center", bgcolor: "rgba(255,255,255,0.75)"}}>
                                            <HugeiconsIcon icon={metric.icon} size={15} color={metric.color}/>
                                        </Box>
                                        <Box sx={{minWidth: 0}}>
                                            <Typography fontSize={18} fontWeight={700} sx={{lineHeight: 1.1, color: "#475569"}}>{metric.value}</Typography>
                                            <Typography fontSize={9} color="text.secondary" sx={{textTransform: "uppercase", letterSpacing: 0.5}}>{metric.label}</Typography>
                                        </Box>
                                    </Stack>
                                ))}
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            );
        })}
    </Box>
);
